import * as React from 'react';
import NavMenu from './NavMenu';

export default (props: { children?: React.ReactNode }) => (
    <React.Fragment>
        <NavMenu/>
        <div style={{ paddingLeft: 90, paddingTop: 70 }}>
            {props.children}
        </div>
    </React.Fragment>
);